import Zdog from 'zdog';

function _async(f) {
  return function () {
    var arguments$1 = arguments;

    for (var args = [], i = 0; i < arguments.length; i++) {
      args[i] = arguments$1[i];
    }

    try {
      return Promise.resolve(f.apply(this, args));
    } catch (e) {
      return Promise.reject(e);
    }
  };
}

var props = {
  svg: {
    type: Boolean
  },
  resize: {
    type: [Boolean, String]
  },
  dragRotate: {
    type: Boolean
  },
  zoom: {
    type: Number
  },
  centered: {
    type: Boolean,
    default: true
  },
  translate: {
    type: Object
  },
  // TODO add custom validators
  rotate: {
    type: Object
  },
  scale: {
    type: Object
  }
};

function _await(value, then, direct) {
  if (direct) {
    return then ? then(value) : value;
  }

  if (!value || !value.then) {
    value = Promise.resolve(value);
  }

  return then ? value.then(then) : value;
}

var ZIllustration = {
  name: "ZIllustration",
  props: Object.assign({}, props, {
    autoRendering: {
      default: true,
      type: Boolean
    }
  }),

  provide: function provide() {
    var this$1 = this;

    var _this = this;

    var vm = this;
    return {
      zdog: {
        get parent() {
          return vm.__zIllustration;
        },

        notifyUpdate: function () {
          this$1.$nextTick(function () {
            this$1.$emit("zdog:update");
          });
        },
        onReady: _async(function () {
          return _this.__readyPromise;
        })
      }
    };
  },

  created: _async(function () {
    var _this2 = this;

    _this2.__readyPromise = new Promise(function (resolve) {
      _this2.$once("zdog:ready", resolve);
    });
    return _await(_this2.__readyPromise, function () {
      _this2.animate();

      _this2.$watch("autoRendering", _this2.animate);
    });
  }),

  mounted: function mounted() {
    this.__zIllustration = new Zdog.Illustration(Object.assign({
      element: this.$el
    }, this.zDogsProps));
    this.$emit("zdog:ready", this.__zIllustration); // this.$on('zdog:update', () => {
    //   this.__zIllustration.updateRenderGraph()
    // })
  },

  computed: {
    zDogsProps: function zDogsProps() {
      var this$1 = this;

      return Object.keys(props).reduce(function (obj, key) {
        var obj$1;

        return Object.assign({}, obj, ( obj$1 = {}, obj$1[key] = this$1.$props[key], obj$1 ));
      }, {});
    }

  },
  methods: {
    animate: function animate() {
      this.__zIllustration.updateRenderGraph();

      this.$emit("tick");
      if (this.autoRendering) { requestAnimationFrame(this.animate); }
    }

  },

  render: function render(h) {
    var tag = this.svg ? "svg" : "canvas";
    return h(tag, {
      props: this.$attrs
    }, this.$slots.default);
  }

};

function _await$1(value, then, direct) {
  if (direct) {
    return then ? then(value) : value;
  }

  if (!value || !value.then) {
    value = Promise.resolve(value);
  }

  return then ? value.then(then) : value;
}

function _async$1(f) {
  return function () {
    var arguments$1 = arguments;

    for (var args = [], i = 0; i < arguments.length; i++) {
      args[i] = arguments$1[i];
    }

    try {
      return Promise.resolve(f.apply(this, args));
    } catch (e) {
      return Promise.reject(e);
    }
  };
}

var ZShapeFactory = (function (shapeName, extendedProps) {
  var props = Object.assign({
    // ZDOG API
    translate: {
      type: Object
    },
    // TODO add custom validators
    rotate: {
      type: Object
    },
    scale: {
      type: Object
    }
  }, extendedProps);
  return {
    name: ("Z" + shapeName),
    inject: ["zdog"],

    provide: function provide() {
      var vm = this;
      var zdog = Object.assign({}, vm.zdog);
      Object.defineProperty(zdog, "parent", {
        get: function get() {
          return vm.__zEl;
        }

      });
      return {
        zdog: zdog
      };
    },

    props: props,
    created: _async$1(function () {
      var _this = this;

      _this.__zEl = new Zdog[shapeName]();

      _this.setupPropWatcher();

      return _await$1(_this.zdog.onReady(), function () {
        _this.zdog.parent.addChild(_this.__zEl);

        _this.zdog.notifyUpdate();
      });
    }),

    destroyed: function destroyed() {
      this.zdog.parent.removeChild(this.__zEl);
      this.zdog.notifyUpdate();
    },

    methods: {
      setupPropWatcher: function setupPropWatcher() {
        var this$1 = this;

        var createHandler = function (name) { return function (newVal) {
          this$1.__zEl[name] = newVal;
          this$1.__zEl.updatePath && this$1.__zEl.updatePath(); // no setters yet in the API we need to explicitly refresh the shape

          this$1.zdog.notifyUpdate();
        }; };

        var loop = function () {
          var key = list[i];

          this$1.$watch(function () { return this$1.$props[key]; }, createHandler(key), {
            immediate: true,
            deep: true
          });
        };

        for (var i = 0, list = Object.keys(props); i < list.length; i += 1) loop();
      }

    },

    render: function render(h) {
      return h("div", this.$slots.default);
    }

  };
});

var commonShapeProps = {
  stroke: {
    type: [Number, Boolean]
  },
  fill: {
    type: Boolean
  },
  color: {
    type: String
  },
  closed: {
    type: Boolean,
    default: true
  },
  visible: {
    type: Boolean,
    default: true
  },
  backface: {
    type: [String, Boolean],
    default: true
  }
};
var ZAnchor = ZShapeFactory("Anchor", {});
var ZGroup = ZShapeFactory("Group", {});
var ZRect = ZShapeFactory("Rect", Object.assign({}, commonShapeProps, {
  width: {
    required: true,
    type: Number
  },
  height: {
    required: true,
    type: Number
  }
}));
var ZRoundedRect = ZShapeFactory("RoundedRect", Object.assign({}, commonShapeProps, {
  width: {
    required: true,
    type: Number
  },
  height: {
    required: true,
    type: Number
  },
  cornerRadius: {
    type: Number
  }
}));
var ZEllipse = ZShapeFactory("Ellipse", Object.assign({}, commonShapeProps, {
  width: {
    type: Number
  },
  height: {
    type: Number
  },
  diameter: {
    type: Number
  },
  quarters: {
    type: Number
  }
}));
var ZPolygon = ZShapeFactory("Polygon", Object.assign({}, commonShapeProps, {
  radius: {
    required: true,
    type: Number
  },
  sides: {
    required: true,
    type: Number
  }
}));
var ZShape = ZShapeFactory("Shape", Object.assign({}, commonShapeProps, {
  path: {
    required: true,
    type: Array
  },
  closed: {
    type: Boolean
  }
}));
var ZHemisphere = ZShapeFactory("Hemisphere", Object.assign({}, commonShapeProps, {
  diameter: {
    required: true,
    type: Number
  }
}));
var ZCone = ZShapeFactory("Cone", Object.assign({}, commonShapeProps, {
  diameter: {
    required: true,
    type: Number
  },
  length: {
    required: true,
    type: Number
  }
}));
var ZCylinder = ZShapeFactory("Cylinder", Object.assign({}, commonShapeProps, {
  diameter: {
    required: true,
    type: Number
  },
  length: {
    required: true,
    type: Number
  },
  frontFace: {
    type: [String, Boolean],
    default: true
  },
  backFace: {
    type: [String, Boolean],
    default: true
  }
}));
var ZBox = ZShapeFactory("Box", Object.assign({}, commonShapeProps, {
  width: {
    required: true,
    type: Number
  },
  height: {
    required: true,
    type: Number
  },
  depth: {
    required: true,
    type: Number
  },
  leftFace: {
    type: [String, Boolean],
    default: true
  },
  rightFace: {
    type: [String, Boolean],
    default: true
  },
  rearFace: {
    type: [String, Boolean],
    default: true
  },
  frontFace: {
    type: [String, Boolean],
    default: true
  },
  topFace: {
    type: [String, Boolean],
    default: true
  },
  bottomFace: {
    type: [String, Boolean],
    default: true
  }
}));

export { ZAnchor, ZBox, ZCone, ZCylinder, ZEllipse, ZGroup, ZHemisphere, ZIllustration, ZPolygon, ZRect, ZRoundedRect, ZShape };
